import { render, staticRenderFns } from "./MpCalculator.vue?vue&type=template&id=546eb4f5&"
import script from "./MpCalculator.vue?vue&type=script&lang=js&"
export * from "./MpCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports